"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptDrivedDeployer = void 0;
const dbgate_tools_1 = require("dbgate-tools");
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const logger = (0, dbgate_tools_1.getLogger)('ScriptDrivedDeployer');
class ScriptDrivedDeployer {
    constructor(dbhan, driver, files, crypto) {
        this.dbhan = dbhan;
        this.driver = driver;
        this.files = files;
        this.crypto = crypto;
        this.predeploy = [];
        this.uninstall = [];
        this.install = [];
        this.once = [];
        this.postdeploy = [];
        this.isEmpty = false;
        this.journalItems = [];
        this.predeploy = files.filter(x => x.name.endsWith('.predeploy.sql'));
        this.uninstall = files.filter(x => x.name.endsWith('.uninstall.sql'));
        this.install = files.filter(x => x.name.endsWith('.install.sql'));
        this.once = files.filter(x => x.name.endsWith('.once.sql'));
        this.postdeploy = files.filter(x => x.name.endsWith('.postdeploy.sql'));
        this.isEmpty =
            this.predeploy.length === 0 &&
                this.uninstall.length === 0 &&
                this.install.length === 0 &&
                this.once.length === 0 &&
                this.postdeploy.length === 0;
    }
    loadJournalItems() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { rows } = yield (0, dbgate_tools_1.runQueryOnDriver)(this.dbhan, this.driver, dmp => dmp.put('select * from ~dbgate_deploy_journal'));
                this.journalItems = rows;
                logger.debug(`Loaded ${rows.length} items from DbGate deploy journal`);
            }
            catch (err) {
                logger.warn((0, dbgate_tools_1.extractErrorLogData)(err), 'Error loading DbGate deploy journal, creating table dbgate_deploy_journal');
                const dmp = this.driver.createDumper();
                dmp.createTable({
                    pureName: 'dbgate_deploy_journal',
                    columns: [
                        { columnName: 'id', dataType: 'int', autoIncrement: true, notNull: true, pureName: 'dbgate_deploy_journal' },
                        { columnName: 'name', dataType: 'varchar(100)', notNull: true, pureName: 'dbgate_deploy_journal' },
                        { columnName: 'category', dataType: 'varchar(100)', notNull: true, pureName: 'dbgate_deploy_journal' },
                        { columnName: 'script_hash', dataType: 'varchar(100)', notNull: true, pureName: 'dbgate_deploy_journal' },
                        { columnName: 'first_run_date', dataType: 'varchar(100)', notNull: true, pureName: 'dbgate_deploy_journal' },
                        { columnName: 'last_run_date', dataType: 'varchar(100)', notNull: true, pureName: 'dbgate_deploy_journal' },
                        { columnName: 'run_count', dataType: 'int', notNull: true, pureName: 'dbgate_deploy_journal' },
                    ],
                    foreignKeys: [],
                    primaryKey: {
                        columns: [{ columnName: 'id' }],
                        constraintType: 'primaryKey',
                        pureName: 'dbgate_deploy_journal',
                    },
                });
                yield this.driver.query(this.dbhan, dmp.s, { discardResult: true });
            }
        });
    }
    runPre() {
        return __awaiter(this, void 0, void 0, function* () {
            // don't create journal table if no scripts are present
            if (this.isEmpty)
                return;
            yield this.loadJournalItems();
            yield this.runFiles(this.predeploy, 'predeploy');
        });
    }
    runPost() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.runFiles(this.install, 'install');
            yield this.runFiles(this.once, 'once');
            yield this.runFiles(this.postdeploy, 'postdeploy');
        });
    }
    run() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.runPre();
            yield this.runPost();
        });
    }
    runFiles(files, category) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const file of (0, sortBy_1.default)(files, x => x.name)) {
                yield this.runFile(file, category);
            }
        });
    }
    saveToJournal(file, category, hash) {
        return __awaiter(this, void 0, void 0, function* () {
            const existing = this.journalItems.find(x => x.name == file.name);
            if (existing) {
                yield (0, dbgate_tools_1.runCommandOnDriver)(this.dbhan, this.driver, dmp => {
                    dmp.put('update ~dbgate_deploy_journal set ~last_run_date = %v, ~script_hash = %v, ~run_count = ~run_count + 1 where ~id = %v', new Date().toISOString(), hash, existing.id);
                });
            }
            else {
                yield (0, dbgate_tools_1.runCommandOnDriver)(this.dbhan, this.driver, dmp => {
                    dmp.put('insert into ~dbgate_deploy_journal (~name, ~category, ~first_run_date, ~last_run_date, ~script_hash, ~run_count) values (%v, %v, %v, %v, %v, 1)', file.name, category, new Date().toISOString(), new Date().toISOString(), hash);
                });
            }
        });
    }
    runFileCore(file, category, hash) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.driver.supportsTransactions) {
                (0, dbgate_tools_1.runCommandOnDriver)(this.dbhan, this.driver, dmp => dmp.beginTransaction());
            }
            logger.debug(`Running ${category} script ${file.name}`);
            try {
                yield this.driver.script(this.dbhan, file.text, { useTransaction: false });
                yield this.saveToJournal(file, category, hash);
            }
            catch (err) {
                logger.error((0, dbgate_tools_1.extractErrorLogData)(err), `Error running ${category} script ${file.name}`);
                if (this.driver.supportsTransactions) {
                    (0, dbgate_tools_1.runCommandOnDriver)(this.dbhan, this.driver, dmp => dmp.rollbackTransaction());
                    return;
                }
            }
            if (this.driver.supportsTransactions) {
                (0, dbgate_tools_1.runCommandOnDriver)(this.dbhan, this.driver, dmp => dmp.commitTransaction());
            }
        });
    }
    runFile(file, category) {
        return __awaiter(this, void 0, void 0, function* () {
            const hash = this.crypto.createHash('md5').update(file.text.trim()).digest('hex');
            const journalItem = this.journalItems.find(x => x.name == file.name);
            const isEqual = journalItem && journalItem.script_hash == hash;
            switch (category) {
                case 'predeploy':
                case 'postdeploy':
                    yield this.runFileCore(file, category, hash);
                    break;
                case 'once':
                    if (journalItem)
                        return;
                    yield this.runFileCore(file, category, hash);
                    break;
                case 'install':
                    if (isEqual)
                        return;
                    const uninstallFile = this.uninstall.find(x => x.name == file.name.replace('.install.sql', '.uninstall.sql'));
                    if (uninstallFile && journalItem) {
                        // file was previously installed, uninstall first
                        yield this.runFileCore(uninstallFile, 'uninstall', this.crypto.createHash('md5').update(uninstallFile.text.trim()).digest('hex'));
                    }
                    yield this.runFileCore(file, category, hash);
                    break;
            }
        });
    }
}
exports.ScriptDrivedDeployer = ScriptDrivedDeployer;
